import React from 'react';
import { Modal } from 'components';
import { useNavigate } from 'react-router-dom';
import { CheckEmail } from '../modal/checkEmail';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import { useWarehouseForgotPassword } from './useWarehouseForgotPassword';
import { ForgotPasswordForm, ForgotPasswordFormData } from 'components/auth';
import { WarehouseAuthContainer } from '../components/WarehouseAuthContainer';

export const WarehouseForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const { onFinish, onModalClose, isModalOpen, onModalOk, form, isLoading, contextHolder } =
    useWarehouseForgotPassword();

  const handleBackToLogin = () => {
    navigate(WAREHOUSE_ROUTES.warehouseSignIn);
  };

  const handleFormSubmit = (values: ForgotPasswordFormData) => {
    onFinish(values);
  };

  return (
    <>
      {contextHolder}
      <WarehouseAuthContainer
        title="Reset Password"
        description="Enter your email and we'll send you instructions to reset your password"
        bottomLinkText="Back to Sign In"
        bottomLinkAction={handleBackToLogin}
      >
        <ForgotPasswordForm
          form={form}
          onFinish={handleFormSubmit}
          loading={isLoading}
          submitButtonText="Request Reset Link"
          showBackToLogin={false}
        />
      </WarehouseAuthContainer>
      <Modal closable={false} width={330} open={isModalOpen} footer={null} onCancel={onModalClose}>
        <CheckEmail onOk={onModalOk} />
      </Modal>
    </>
  );
};
